import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { useIsAgoda } from '@contexts/app/hooks/useIsAgoda';

export const useIsYCS = () => {
    const { appId } = useAppContext();
    return appId?.toLocaleLowerCase() === 'ycs';
};

export const useIsYCSAgoda = () => {
    return useIsYCS() && useIsAgoda();
};

export const useIsYCSApp = () => {
    const { appId } = useAppContext();
    return appId?.toLocaleLowerCase() === 'ycsapp';
};

export const useIsYCSAppAgoda = () => {
    return useIsYCSApp() && useIsAgoda();
};

export const isMLDCDomain = () => {
    return (
        window.location.host === 'ycs.agoda.com' ||
        window.location.host === 'pics.jtb.co.jp' ||
        window.location.host === 'www.ycsforwl.com'
    );
};
